export function StatsSection({ artistCount }) {
  const stats = [
    { value: `${artistCount}+`, label: 'Top Artists' },
    { value: '24h', label: 'Avg Response' },
    { value: '100%', label: 'Secure Payments' },
    { value: '45', label: 'Day Guarantee' },
  ];
  return (
    <section className="py-12 border-y border-[#1E1E1E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-mono text-3xl sm:text-4xl font-bold text-lime mb-2">{s.value}</div>
              <div className="text-sm text-[#A1A1AA]">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
